module.exports = __webpack_public_path__ + "img/camel_1995.01759864.jpg";